/* global breakpointMd, windowWidth, attachEvent, slideUp, slideDown */

// **********************************************************
// Filter dropdown
// **********************************************************
attachEvent('.has-dropdown .filter__link', 'click', (ev) => {
  if (windowWidth() < breakpointMd) {
    const linkParent = ev.target.closest('.filter__item');
    const filterDropdown = linkParent.querySelector('.filter__dropdown');

    if (linkParent.classList.contains('is-open-dropdown')) {
      slideUp(filterDropdown, 300);
      linkParent.classList.remove('is-open-dropdown');
    } else {
      linkParent.classList.add('is-open-dropdown');
      slideDown(filterDropdown, 300);
    }
  }
});

// **********************************************************
// Open Search-box
// **********************************************************

attachEvent('.filter-search', 'click', (ev) => {
  const searchParent = ev.target.closest('.filter');
  searchParent.classList.add('is-open-search');
  ev.preventDefault();
});

// **********************************************************
// Close Search-box
// **********************************************************

attachEvent('.filter-clear', 'click', (ev) => {
  const searchParent = ev.target.closest('.filter');
  searchParent.classList.remove('is-open-search');
});
